import { Fragment, type ReactNode } from 'react';
import { Inbox, type LucideIcon } from 'lucide-react';
import { Badge, Card, KpiCard } from '@evi/ui';
import { salesStatusTone } from '@/lib/salesPresentation';
import { splitSalesCopy } from '@/lib/salesTeamCopy';
import header from '../network-submissions/NetworkSubmissions.module.css';
import styles from './SalesTeam.module.css';

/** Reuse the Submit a Location header and the Admin's shared card/stat/badge kit. */
export function SalesPage({ title, subtitle, icon: Icon, children }: { title: string; subtitle: string; icon: LucideIcon; children: ReactNode }) {
  return <main className={styles.page}>
    <header className={header.header}><div className={header.headerLeft}>
      <div className={header.headerIcon}><Icon size={18} /></div>
      <div><h1 className={header.title}>{title}</h1><p className={header.subtitle}>{subtitle}</p></div>
    </div></header>{children}
  </main>;
}
export function SalesCard({ title, children, action }: { title: string; children: ReactNode; action?: ReactNode }) {
  return <Card data-sales-card className={`${styles.card} ${styles.stack}`}><div className={styles.cardHead}><h2>{title}</h2>{action}</div>{children}</Card>;
}
export function SalesEmpty({ title, children }: { title: string; children: ReactNode }) {
  return <div className={styles.empty}><Inbox size={24} aria-hidden /><strong>{title}</strong><p>{children}</p></div>;
}
export function SalesStat({ label, value, meta }: { label: string; value: string | number; meta?: string }) {
  return <KpiCard label={label} value={String(value)} meta={meta} />;
}
/** The tone always follows the recorded value; label only changes the words shown for it. */
export function SalesStatus({ value, label }: { value: string; label?: string }) {
  return <Badge className={styles.badge} variant={salesStatusTone(value)}>{(label ?? value).replaceAll('_', ' ')}</Badge>;
}
/** A copy template whose {placeholders} are elements, rendered in place so the sentence keeps its word order in every language. */
export function SalesFill({ text, values }: { text: string; values: Readonly<Record<string, ReactNode>> }) {
  return <>{splitSalesCopy(text).map((part, i) => <Fragment key={i}>{'name' in part ? values[part.name] : part.text}</Fragment>)}</>;
}
